import React, { Fragment as _ } from 'react';

const AssessmentIncorrect = ({ color = '#9E6CFF' }: { color: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      aria-describedby="title"
    >
      <title>Incorrect</title>
      <circle
        cx="11"
        cy="11"
        r="10.5"
        style={{
          stroke: color,
        }}
        // stroke="#9E6CFF"
      />
      <path
        d="M8 8L14 14"
        style={{
          stroke: color,
          strokeLinecap: 'round',
        }}
        // stroke="#9E6CFF"
        // stroke-linecap="round"
      />
      <path
        d="M8 14L14 8"
        style={{
          stroke: color,
          strokeLinecap: 'round',
        }}
        // stroke="#9E6CFF"
        // stroke-linecap="round"
      />
    </svg>
  );
};

export default AssessmentIncorrect;
